import script from "./DashboardUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardUser.vue?vue&type=script&setup=true&lang=js"

import "./DashboardUser.vue?vue&type=style&index=0&id=2d105da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d105da4"]])

export default __exports__